export const LOAD_BATCH_INFO_WIDGET_DATA_REQUEST = "[DASHBOARD] LOAD_BATCH_INFO_WIDGET_DATA_REQUEST";
